import _clonedeep from 'lodash/cloneDeep';

function addressBook(state = {}, action) {
  switch (action.type) {
    case 'SET_ADDRESS_DATA':
      let {
        addresses = [],
        preferredStorePincode = '',
        showStorePickUpTabForUser = 0
      } = action.addresses;
      let newState = {};
      if (!state.id && addresses.length) {
        newState = {
          ...state,
          id: addresses[0].id,
          postalCode: addresses[0].postalCode,
          activeIndex: 0
        };
      }
      newState = {
        ...state,
        ...newState,
        preferredStorePincode,
        showStorePickUpTabForUser,
        addresses: action.addresses.addresses
      };
      return newState;

    case 'GET_ADDRESS_SUCCESS':
      return { ...state, success: action.success };

    case 'SET_ACTIVE_INDEX':
      return {
        ...state,
        activeIndex: action.activeIdx
      };
    case 'GET_ADDRESS_FAIL':
      return { ...state, success: action.success };

    case 'ADD_ADDRESS_SUCCESS':
      return { ...state, addAddresssuccess: action.addAddresssuccess };

    case 'ADD_ADDRESS_FAIL':
      return { ...state, addAddresssuccess: action.addAddresssuccess };

    case 'EDIT_ADDRESS_SUCCESS':
      return { ...state, editAddresssuccess: action.editAddresssuccess };

    case 'EDIT_ADDRESS_FAIL':
      return { ...state, editAddresssuccess: action.editAddresssuccess };

    case 'DELETE_ADDRESS_SUCCESS':
      let { id: addressId = '', delAddresssuccess } = action;
      let newAddrState = {};
      if (state.id == addressId) {
        newAddrState = {
          ...state,
          id: '',
          postalCode: '',
          activeIndex: -1
        };
      }
      newAddrState = { ...newAddrState, delAddresssuccess };
      return newAddrState;

    case 'DELETE_ADDRESS_FAIL':
      return { ...state, delAddresssuccess: action.delAddresssuccess };

    case 'SET_ADDRESS_ID':
      return { ...state, id: action.id, postalCode: action.postalCode, activeIndex: action.index };

    case 'SET_STORE_ADDRESS_ID':
      let storeNode = _clonedeep(state);
      let { storeAddressList } = storeNode;
      if (storeAddressList.storeNodes) {
        storeNode = storeAddressList.storeNodes[action.index];
        return {
          ...state,
          id: action.id,
          postalCode: action.postalCode,
          activeIndexStore: action.index,
          selectedStoreNode: storeNode
        };
      }

    case 'SET_POSTAL_DATA':
      return { ...state, postalData: action.postalData };

    case 'RESET_POSTAL_DATA':
      return { ...state, postalData: {} };

    case 'SET_POSTAL_CODE':
      return { ...state, postalCode: action.postalCode };

    case 'SET_STORE_ADDRESS_LIST':
      return { ...state, storeAddressList: action.data };

    case 'RESET_STORE_ADDRESS_DATA':
      return { ...state, storeAddressList: {}, activeIndexStore: -1 };

    case 'SET_FRAUD_CHECKED_COD_AVAILABILITY':
      return { ...state, isFraudCheckedCODAvailable: action.isAvailable };

    case 'RESET_FRAUD_CHECKED_COD_AVAILABILITY':
      return { ...state, isFraudCheckedCODAvailable: false };

    default:
      return state;
  }
}

export default addressBook;
